export const ERROR_STATISTICS_GET_LATEST = 'ERROR_STATISTICS_GET_LATEST'
export const ERROR_STATISTICS_GET_KPIS = 'ERROR_STATISTICS_GET_KPIS'
export const ERROR_STATISTICS_SHOW_MODAL = 'ERROR_STATISTICS_SHOW_MODAL'
export const ERROR_STATISTICS_HIDE_MODAL = 'ERROR_STATISTICS_HIDE_MODAL'
export const ERROR_SET_ERROR_TAB = "ERROR_SET_ERROR_TAB";
export const ERROR_GET_ERROR_BY_DATE = "ERROR_GET_ERROR_BY_DATE";